export enum PageTitleInterface {
    Login = 'Login',
    NoUrl = 'No Url',
    CalibrationGroup = 'Calibration Groups',
    CalibrationGroupReport = 'Calibration Group Report',
    CalibrationUser = 'Calibration Participants',
    CalibrationUserReport = 'Calibration User Report',
    AiManagementReport = 'Management AI Report',
    CreateUser = 'Create User',
    Dashboard = 'Dashboard',
    ExternalEvaluation = 'External Evaluation',
    Feedback = 'Feedback',
    FeedbackConfiguration = 'Feedback Configuration',
    FeedbackQRCODE = 'Feedback QR CODE',
    FinalFeedback = 'Final Feedback',
    FinalFeedbackValidation = 'Final Feedback Validation',
    FirstAccess = 'First Access',
    FreeEvalEndYear = 'Free Eval End Year',
    FreeEvalMidYear = 'Free Eval Mid Year',
    GoalsInput = 'Goals Input',
    GoalsReview = 'Goals Review',
    GoalsReviewValidation = 'Goals Review Validation',
    GoalsValidation = 'Goals Validation',
    GoalsValidationInput = 'Goals Validation Input',
    ManageCycle = 'Manage Cycle',
    ManageCycleParticipants = 'Manage Cycle Participants',
    ManageExternalEvaluation = 'Manage External Evaluation',
    ManageGenericProcess = 'Manage Generic Process',
    ManageHRChannel = 'Manage HR Channel',
    ManageProcess = 'Manage Process',
    ManageUser = 'Manage User',
    ManageUserVisibility = 'Manage User Visibility',
    ManagerEval = 'Manager Eval',
    HeadEval = 'Head Eval',
    NewGoalsInput = 'New Goals Input',
    Notepad = 'Notepad',
    OKR = 'OKR',
    OKRAttributeAssociation = 'OKR Attribute Association',
    OKRConfiguration = 'OKR Configuration',
    PerformanceCycle = 'Performance Cycle',
    Process = 'Process',
    Reports = 'Reports',
    SelfEval = 'Self Eval',
    SelfEvalMidYear = 'Self Eval Mid Year',
    ThreeSixtyEval = 'ThreeSixty Eval',
    ThreeSixtySelection = 'ThreeSixty Selection',
    ThreeSixtyValidation = 'ThreeSixty Validation',
    UserFeedback = 'User Feedback',
    UserFeedbackRecord = 'User Feedback Record',
    UserFinalReport = 'User Final Report',
    UsersList = 'Users List',
    UsersSyncProcess = 'Users Sync Process',
    UsersVisibility = 'Users Visibility',
    UserSyncProcess = 'User Sync Process',
    Parameters = 'Parameters',
    ReviewsConfig = 'Reviews Config',
    Profile = 'Profile',
    CalibrationExecutiveBook = "Calibration Executive Book",
    CalibrationExcellentCard = "Calibration Excellent Card",
}